// mixins/datePickerMixin.js
import { mapGetters, mapMutations } from 'vuex'

export const datePickerMixin = {
    computed: {
        ...mapGetters('billing', ['getStartDate', 'getEndDate']),

        startDate: {
            get() {
                return this.getStartDate
            },
            set(value) {
                this.setStartDate(value)
            }
        },
        endDate: {
            get() {
                return this.getEndDate
            },
            set(value) {
                this.setEndDate(value)
            }
        }
    },
    methods: {
        ...mapMutations('billing', ['setStartDate', 'setEndDate']),
    }
}